import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const getPartnersFunc = createAsyncThunk(
  "getPartners",
  async (query = "", thunkAPI) => {
    try {
      const response = await api.get(`dashboard/partners${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const getPartnersSlicer = createSlice({
  name: "getPartners",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartnersFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getPartnersFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data?.partners || action.payload?.partners || [];
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getPartnersFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getPartnersSlicer.reducer;
